import { AppPermission } from 'src/app/models/appEnums';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs';
import { State } from '../store';

@Injectable({ providedIn: 'root' })
export class CredentialTransitionManagementGuard
{
  constructor(private store: Store<State>, private router: Router)
  {
  }

  canActivate()
  {
    if (!localStorage.getItem('currentUser'))
      return this.router.createUrlTree(['/login']);

    return this.store.select(s => s.accountState.user).pipe(
      filter(user => !!user),
      take(1),
      map(user =>
        user.permissionIDs?.includes(AppPermission.CredentialTransitionsManage)
        || user.permissionIDs?.includes(AppPermission.CredentialTransitionsView)
        || user.permissionIDs?.includes(AppPermission.CredentialTransitionsEdit)
        || this.router.createUrlTree(['/management']))
    );
  }
}
